/**
 * Transform the API DTO (IUserDTO) into the form shape (IUserForm).
 * Pure function: no React, no Redux, no i18n.
 */

import { setMetadataArraySelect, setMetadataSelect } from 'app/services/metadata.service';
import type { SelectOption } from '../_shared.types';
import { Model } from './user.defaults';
import type { IUserDTO, IUserForm } from './user.types';

function getSchool(data: IUserDTO): IUserForm['school'] {
  const isPersonalSchool = data?.schools?.length
    ? Boolean(data.schools[0].name?.includes(data.guid ?? ''))
    : false;
  if (isPersonalSchool) return {};
  const sanitized = setMetadataArraySelect(data.schools ?? []);
  return sanitized[0] ?? {};
}

export function sanitizeData(data: IUserDTO): IUserForm {
  return {
    ...Model,
    guid: data.guid,
    avatar: data.avatar ? data.avatar : Model.avatar,
    country: data.country_guid
      ? (setMetadataSelect(data, 'country_name', 'country_guid') as SelectOption)
      : Model.country,
    country_guid: data.country_guid ?? '',
    groups: setMetadataArraySelect(data.groups ?? []),
    groupsOld: setMetadataArraySelect(data.groups ?? []),
    has_license_mint: !!data.has_license_mint,
    is_demo: !!data.is_demo,
    is_tangerine_ai: !!data.is_tangerine_ai,
    lastname: data.lastname ? data.lastname : Model.lastname,
    name: data.name ? data.name : Model.name,
    oraculo_id: data.oraculo_id ?? Model.oraculo_id,
    role: data.role_guid ?? Model.role,
    school: getSchool(data),
    schools: setMetadataArraySelect(data.schools ?? []),
    schoolsOld: setMetadataArraySelect(data.schools ?? []),
    subscription: data?.subscription,
    username: data.username ? data.username : Model.username,
  };
}
